export default function LinkedInIcon({ className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21.074"
      height="21.036"
      viewBox="0 0 21.074 21.036"
      className={`h-6 fill-current ${className}`}
    >
      <g transform="translate(-210.188 -471.208)">
        <g transform="translate(210.188 471.208)">
          <path
            d="M153.872,470.572h4.371v14.051h-4.371Zm2.187-6.985a2.532,2.532,0,1,1-2.533,2.532,2.533,2.533,0,0,1,2.533-2.532"
            transform="translate(-153.525 -463.587)"
            fill="#bebebe"
          />
          <path
            d="M170.369,478.924h4.186v1.921h.06a4.587,4.587,0,0,1,4.132-2.269c4.422,0,5.239,2.909,5.239,6.693v7.706h-4.367v-6.833c0-1.63-.028-3.726-2.269-3.726-2.272,0-2.619,1.776-2.619,3.609v6.95h-4.362Z"
            transform="translate(-162.912 -471.94)"
            fill="#bebebe"
          />
        </g>
      </g>
    </svg>
  );
}
